export enum DealRoomDepartment {
  SALES = 'sales',
  INNOVATIONS_A = 'innovations-a',
  INNOVATIONS_B = 'innovations-b',
  CLAIMS = 'claims',
  CUSTOMER_SERVICE = 'customer-service',
  PIPE_ARRANGEMENT = 'pipe-arrangement',
  COLLECTION = 'collection',
  MANAGEMENT_COMPANIES = 'management-companies',
}
